import { ref, watchEffect, onUnmounted } from 'vue'

export const useFocus = (selfRef, modalRef = selfRef) => {
  const focus = ref(false)
  const checkDOM = document.body
  
  const clickChangeFocus = (ev) => {
    if (!selfRef.value.contains(ev.target) && !modalRef.value.contains(ev.target) ) {
      focus.value = false
    }
  }
  const selfClickHandler = (ev: MouseEvent) => {
    focus.value = true
    ev.stopPropagation()
  }

  let cahceSelf = selfRef.value
  watchEffect(() => {
    cahceSelf && cahceSelf.removeEventListener('mouseenter', selfClickHandler)
    selfRef.value && selfRef.value.addEventListener('mouseenter', selfClickHandler)
    cahceSelf = selfRef.value
  })

  watchEffect(() => {
    if (modalRef.value && focus.value) {
      checkDOM.addEventListener('mouseenter', clickChangeFocus, { capture: true })
    } else {
      checkDOM.removeEventListener('mouseenter', clickChangeFocus, { capture: true })
    }
  })

  onUnmounted(() => {
    cahceSelf && cahceSelf.removeEventListener('mouseenter', selfClickHandler)
    checkDOM.removeEventListener('mousedown', clickChangeFocus)
  })

  return focus
}

export default useFocus